<ion-item *ngFor="let number of [].constructor(2); let i = index"
          [color]="i % 2 === 0 ? 'whitesmoke' : ''"
          lines="none">
  <ion-col size="1">
    <ion-skeleton-text animated class="diner-avatar"></ion-skeleton-text>
  </ion-col>
  <ion-col size="9">
    <ion-skeleton-text animated class="diner-info"></ion-skeleton-text>
    <ion-skeleton-text animated class="diner-info"></ion-skeleton-text>
    <ion-skeleton-text animated class="diner-info"></ion-skeleton-text>
  </ion-col>
  <ion-col size="2">
    <ion-skeleton-text animated></ion-skeleton-text>
  </ion-col>
</ion-item>